import { useEffect, useState } from "react";

/**
 * Local-draft copy of a record list. Mirrors `source` while `editing` is false;
 * entering edit mode freezes the draft so add/update/remove only mutate the local
 * copy until the caller persists it elsewhere.
 */
export const useDraftList = <T extends { id?: unknown }>(source: T[], editing: boolean) => {
  const [draft, setDraft] = useState<T[]>(source);

  useEffect(() => {
    if (!editing) setDraft(source);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [source, editing]);

  const add = (item: T) => setDraft(prev => [...prev, item]);
  const update = (id: T["id"], patch: Partial<T>) =>
    setDraft(prev => prev.map(item => (item.id === id ? { ...item, ...patch } : item)));
  const remove = (id: T["id"]) => setDraft(prev => prev.filter(item => item.id !== id));

  return { draft, add, update, remove };
};
